export default __webpack_public_path__ + "static/media/608.a225a606.svg";